module.exports = __webpack_public_path__ + "files/ccfe6030a78002a881e9dbc222a8d474.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/nature-3.png
// module id = 1374
// module chunks = 59